import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=6b535910&scoped=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettings.vue?vue&type=style&index=0&id=6b535910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b535910",
  null
  
)

export default component.exports